import { moduleCheck } from "@/helpers/module-check";
import * as Sentry from "@sentry/vue";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";
import registerAnalyticsGroup from "@/helpers/register-analytics-group";

export const setCompanyMixin = {
  methods: {
    async setCompany(company, refreshAfterChange = true) {
      const {
        id: company_id,
        is_paying: company_is_paying,
        is_testing: company_is_testing
      } = company;
      const { user_id } = company.company_user;

      Sentry.setUser({ id: user_id });

      localStorage.setItem(LOCAL_STORAGE_KEYS.COMPANY_ID, company.id);
      this.$store.dispatch("company/setCompany", {
        company
      });
      this.$store.dispatch("externalChanges/fetchProtectionSummary");
      this.searchQuery = "";

      registerAnalyticsGroup(this.$store.state.company);

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.COMPANY_SELECT,
        company_id
      });
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.SET_USER_DATA,
        company_id,
        user_id,
        company_is_paying,
        company_is_testing
      });
      if (this.$route.query && this.$route.query.companyId) {
        const query = Object.assign({}, this.$route.query);
        delete query["companyId"];
        this.$router.replace({ query }).catch(_err => {});
      }
      if (
        this.$route.meta.hasOwnProperty("module") &&
        !moduleCheck(this.$route.meta.module)
      ) {
        this.$router.replace({ name: "dashboard" });
      }
      if (refreshAfterChange) {
        this.$router.go();
      }
    }
  }
};
